// Vite yields an image import as a URL string; Next yields a StaticImageData
// object. `<img>` needs the string either way.
export const toImageSrc = (image: string): string =>
  typeof image === 'string' ? image : (image as { src: string }).src;
